import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

import fontStyleBuilder from "@/challenges/utils/fontStyleBuilder";

const { ui } = constants.colors;

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs, sm },
} = constants.breakpoints;

const neutral700 = ui.neutral[700];
const grey = ui.neutral[500];

export const ACTIVITIES_CONTENT = "ACTIVITIES_CONTENT";

export const challengeDetailCardCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  width: "100%",
  borderRadius: "16px",
  padding: "16px",
  gap: "16px",
  background: "white",
  transition: "box-shadow 0.3s ease-in-out",
  "&:hover": {
    cursor: "pointer",
    "-webkit-box-shadow": "0px 0px 13px 2px rgba(0,0,0,0.40)",
    "-moz-box-shadow": "0px 0px 13px 2px rgba(0,0,0,0.40)",
    "box-shadow": "rgba(0, 0, 0, 0.15) 0px 8px 12px 2px",
  },
};

export const challengeDetailCardContentCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px",
  width: "100%",
  textAlign: "start",
};

export const challengeDetailCardTitle: CSSObject = {
  width: "100%",
  margin: "8px 0 8px 0",
  color: neutral700,
  maxWidth: "160px",
  ...fontStyleBuilder({
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "120%",
  }),
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  [mq.downTo(xs)]: {
    maxWidth: "340px",
  },
  [mq.downTo(sm)]: {
    maxWidth: "240px",
  },
};

export const cardHeaderBackgroundCss: CSSObject = {
  width: "72px",
  height: "72px",
  borderRadius: "8px",
  [mq.downTo(sm)]: {
    height: "104px",
    width: "104px",
  },
};

export const descriptionChallengeTextCss: CSSObject = {
  width: "100%",
  color: grey,
  margin: 0,
  textOverflow: "ellipsis",
  ...fontStyleBuilder({
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "150%",
  }),
};

export const topicRowCss: CSSObject = {
  width: "100%",
};

export const divider: CSSObject = {
  height: "1px;",
  flexShrink: 0,
  alignSelf: "stretch",
  opacity: "0.16",
  background: neutral700,
};

export const DetailsTextCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "250px",
};
